import { defineMessages } from "react-intl";

export const INTL_MESSAGES = defineMessages({
  modalTitle: {
    id: "contact form: modal title 2",
    defaultMessage: "{name} will reply as soon as possible",
  },
  messageInputTitle: {
    id: "contact form: message input label",
    defaultMessage: "Type your message below",
  },
  messageInputHelperText: {
    id: "contact form: message input helper text",
    defaultMessage: "You can change the description.",
  },
  messageInputPlaceholderText: {
    id: "contact form: message input placeholder text",
    defaultMessage: "Type your message here",
  },
  contactFormSubmitBtnLabel: {
    id: "contact form: contact form submit button",
    defaultMessage: "Submit",
  },
  contactFormCancelBtnLabel: {
    id: "contact form: contact form cancel button",
    defaultMessage: "Cancel",
  },
  contactFormSuccessMessageHeader: {
    id: "contact form: contact form success message header",
    defaultMessage: "Message received!",
  },
  dealOwnerContactFormSuccessMessageBody: {
    id: "contact form: deal owner contact form success message body",
    defaultMessage: "{name} will be in touch with you as soon as possible.",
  },
  contactFormInputError: {
    id: "contact form: contact form input error",
    defaultMessage: "Please enter a message.",
  },
});
